<template>
  <div>
        <van-nav-bar
      @click-left="$router.go(-1)"
      left-arrow
      left-text="返回"  />
      <van-loading style="position:fixed;margin:0 auto;left:50%;top:30%;transform:translate(-50%,0)" 
      color="#1989fa" size="24px" v-show="loading" vertical>
      <div style="color:#1989fa;">
        加载中...
      </div>
    </van-loading>
    <!-- <van-nav-bar @click-left="$router.go(-1)" left-arrow /> -->
    <div v-show="!loading"
      style="padding-bottom: 4rem; padding-top: 0.25rem; margin-bottom: 2rem"
    >
      <div class="card">
        <div class="title">
          <span class="title-new">&nbsp;</span>
          订阅信息
        </div>
        <div class="list">
          <div class="list-item">
            <span>产品名称：</span>
            <span style="color: #1a1a1a">
              <span>{{ query.item.productName }}  ￥<span>{{query.item.productPrice}}</span> </span>
              <!-- <span v-show="!query.item.onePay">
                <span v-if="query.item.productName == '半年卡'">
                 / 6个月
                  <span style="margin: 0 0.45rem">￥55</span>
                </span>
                <span v-if="query.item.productName == '月卡'">
                 / 1个月
                  <span style="margin: 0 0.45rem">￥10</span>
                </span>
                <span v-if="query.item.productName == '年卡'">
                 / 12个月
                  <span style="margin: 0 0.45rem">￥100</span>
                </span>
              </span> -->
            </span>
          </div>
          <div class="list-item">
            <span>订阅人数：</span>
            <span style="color: #1a1a1a">
              {{ query.item.packageName }}
              <span style="margin-left: 0.3rem" v-show="!query.item.onePay">{{ query.item.discount }}</span>
            </span>
          </div>
          <div class="list-item">
            <span>购买人：</span>
            <span style="color: #1a1a1a">{{ userInfo.name }}</span>
            <span style="margin-left: 0.3rem; color: #1a1a1a">{{
              userInfo.mobile
            }}</span>
          </div>
          <div class="list-item" v-if="childList.length > 0">
            <span>孩子信息：</span>
            <div v-for="i in childList" :key="i.childrenName">
              <span v-if="i.id == query.item.childRadio" style="color: #1a1a1a">
                {{ i.name }}
                <span style="margin: 0 0.45rem">{{ i.schoolName }}</span>
                <span>{{ i.className }}</span>
                <br />
                <span
                  v-if="i.status == 0"
                  style="
                    font-size: 0.65rem;
                    color: #666666;
                    position: absolute;
                    padding-top: 0.2rem;"
                  >订阅到期时间：{{ getDateYMD(i.expireDate) }}</span>
                <span
                  v-else
                  style="
                    font-size: 0.75rem;
                    color: #666666;
                    position: absolute;
                    padding-top: 0.2rem;
                  ">未订阅</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- <BindPersonDetail
        v-if="selChildDataItem && selChildDataItem.expireDate"
        :num="this.$route.query.orderNumber?this.$route.query.orderNumber:orderNumber"
      ></BindPersonDetail> -->
      <BindPerson
        :patriarchUserId="patriarchUserId"
        ref="bindPerson"
        :peopleNum="query.item.peopleNum"
        :childId="query.item.childRadio"
        :footShow="footShow"
        @focusFootShow="focusFootShow"
      />
    </div>
    <div class="agree" v-show="footShow&&!loading">
      <van-tabbar
        style="
          border: none;
          padding-top: 1rem;
          padding-bottom: 2rem;
          box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.1);
        "
      >
        <div style="padding-bottom: 1rem; clear: both">
          <div class="sumTotal">
            合计：<span class="money"
              >￥<span style="font-size: 1.65rem">{{
                query.item.realPrice
              }}</span></span>
            <div style="color: #666666">
              已优惠：￥{{ query.item.differencePrice
              }}<span
                style="color: #c29f55; margin-left: 0.7rem"
                @click="showPopup"
                >明细<img src="@/assets/up.png"
              /></span>
            </div>
          </div>
          <div class="btn" @click="payOrder">确认支付</div>
        </div>
      </van-tabbar>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '25%' }">
      <div class="pop">
        原价：<span style="margin-left: 0.75rem"
          >￥{{ query.item.originalPrice }}</span
        >
      </div>
      <div class="pop">
        已优惠：<span>￥{{ query.item.differencePrice }}</span>
      </div>
      <div class="pop">
        合计：<span style="margin-left: 0.75rem"
          >￥{{ query.item.realPrice }}</span
        >
      </div>
      <div class="agree">
        <van-tabbar
          style="border: none; padding-top: 1rem; padding-bottom: 2rem"
        >
          <div style="padding-bottom: 1rem; clear: both">
            <div class="sumTotal">
              合计：<span class="money"
                >￥<span style="font-size: 1.65rem">{{
                  query.item.realPrice
                }}</span></span
              >
              <div style="color: #666666">
                已优惠：￥{{ query.item.differencePrice
                }}<span
                  style="color: #c29f55; margin-left: 0.7rem"
                  @click="closePopup"
                  >明细<img src="@/assets/down.png"
                /></span>
              </div>
            </div>
            <div class="btn" @click="payOrder">确认支付</div>
          </div>
        </van-tabbar>
      </div>
    </van-popup>
  </div>
</template>

<script>
import BindPerson from "./bindPersonCurd";
import wxSDK from "@/utils/wxSDK.service";
import assign from "@/mixins/assign";
import moment from "moment";
import BindPersonDetail from "./bindPersonDetail.vue";
import { isPhone } from "@/utils/validate.js";

export default {
  mixins: [assign],
  data() {
    return {
      loading:true,
      btn_loading: false,
      btn_loading_text: "",
      // query: {},
      childList: [],
      //childRadio: '',
      show: false,
      userInfo: {},
      parentsPayBandingDTOList: [],
      orderNumber: "",
      footShow: true, // 显示或者隐藏footer
      patriarchUserId:''
    };
  },
  mounted() {
    this.getParentsPayAuthChildrenList();
    this.getUserInfoById();
    this.getByChildrenIdOne();
    console.log("订单", this.query);
    this.patriarchUserId=JSON.parse(localStorage.getItem('userInfo')).patriarchUserId;
    // console.log(JSON.parse(localStorage.getItem('userInfo')));
  },
  computed: {
    // id() {
    //   return this.$route.query.id
    // },
    query() {
      return JSON.parse(sessionStorage.getItem("shopping_cart"));
    },
    person() {
      return  this.$refs.bindPerson.addPersonData 
      // return !this.selChildDataItem.expireDate
      //   ? [...this.$refs.bindPerson.addPersonData]
      //   : this.parentsPayBandingDTOList
    },
    notFormperson() {
      return [
        ...this.$refs.bindPerson.addPersonData,
        ...this.$refs.bindPerson.bindDetail,
      ];
    },
    // userInfo() {
    //   return JSON.parse(localStorage.getItem('userInfo'))
    // },
    selChildDataItem() {
      return this.childList.find(
        (item) => item.id == this.query.item.childRadio
      );
    },
    showBtn() {
      let dataItem = this.selChildDataItem;
      return dataItem && !dataItem.orderDTO
        ? true
        : dataItem.orderDTO.userId == dataItem.authUserId;
    },
  },
  methods: {
    focusFootShow(params) {
      console.log('我是确认订单最终选择的值');
      this.footShow = params;
    },
    showPopup() {
      this.show = true;
    },
    closePopup() {
      this.show = false;
    },
    showAlert() {
      // const dis =
      //   this.query.discount == 1 ? '原价' : this.query.discount / 100 + '折'
      this.$dialog
        .alert({
          title: "优惠明细",
          message: "原价 - 享受套餐折扣 × 单价 × 套餐人数 = 优惠价格",
        })
        .then(() => {
          // on close
        });
    },
    getDateYMD(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    // async getAllChild() {
    //   const { code, data } = await this.$https.getAllChild({
    //     userId: this.$store.state.puserId,
    //     schoolId: this.$store.state.pschoolId,
    //   })
    //   if (code !== 200) {
    //     return
    //   }
    //   this.childList = data
    //   this.childRadio = data[0].id
    //   // this.$set(this.form, 'childRadio', data[0].id)
    // },
    async getUserInfoById() {
      console.log("parent", this.$route.query.parentId);
      const { code, data } = await this.$https.getUserInfoById({
        id: this.$route.query.parentId,
      });
      if (code !== 200) {
        return;
      }
      this.userInfo = data;
    },
    async getByChildrenIdOne() {
      const { code, data } = await this.$https.getByChildrenIdOne({
        childId: this.$route.query.childId,
        userId: this.$route.query.parentId,
      });
      if (code !== 200) {
        this.loading=false;
        return;
      }
        this.loading=false;
      this.orderNumber = data && data.orderNumber;
      console.log("order", this.orderNumber);
      try {
        const { code, data } = await this.$https.getSubPersonList({
          //schoolId: this.$store.state.pschoolId,
          orderNum: this.orderNumber,
        });
        if (code !== 200) {
          return false;
        }
        this.parentsPayBandingDTOList = data;
      } catch (error) {}
    },
    async getParentsPayAuthChildrenList() {
      const { code, data } = await this.$https.getParentsPayAuthChildrenList({
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      });
      if (code !== 200) {
        return;
      }
      this.childList = data;
      console.log("孩子信息", this.childList);
      //this.childRadio = data[0].childrenId
    },
    async payOrder() {
      console.log('支付时订阅人');
      console.log(this.$refs.bindPerson.addPersonData );  
      if (this.$refs.bindPerson.radio3.length != 0) {
        if (
          this.$refs.bindPerson.form.bandingUserName == undefined ||
          !this.$refs.bindPerson.form.bandingUserPhone == undefined
        ) {
          this.$toast("请填写信息");
          return;
        }
        if (!isPhone(this.$refs.bindPerson.form.bandingUserPhone)) {
          this.$toast("手机号输入有误");
          return;
        }
        let isExist;
        let pDateIndex;
        if (this.notFormperson.length > 0){
            this.notFormperson.forEach(
            (data,index) =>{
              if(data.bandingUserPhone == this.$refs.bindPerson.form.bandingUserPhone){
                pDateIndex=index;
                isExist=true;
                return false;
              } 
          });
        } 
        if (isExist) {
          // this.$toast("手机号已存在，请勿重复添加");
          this.$toast('第'+(pDateIndex+1)+'个选中的手机号有重复')
          return false;
        }
      }
       if (this.$refs.bindPerson.addPersonData.length<1){
         this.$toast("未选择订阅人员");
         return false;
       }  
      if (
        this.$refs.bindPerson.addPersonData.length > this.query.item.peopleNum
      ) {
        this.$toast('订阅人数仅限'+this.query.item.peopleNum+'人');
        return false;
      } 
      console.log('我是支付时选择的人员');
      console.log(this.query);
        // return;
      try { 
        this.btn_loading = true;
        this.btn_loading_text = "下单中...";
        const result = await this.$https.createOrder({
          originalPrice: this.query.item.originalPrice * 100,
          realPrice: this.query.item.realPrice * 100,
          productId: this.query.item.productId,
          packageId: this.query.item.packageId,
          userId: this.$route.query.parentId,
          userMobile: this.userInfo.mobile,
          schoolId: this.$route.query.schoolId,
          childrenId: this.query.item.childRadio,
          bandingSaveDTOS: [
            ...this.person,
            
            // {
            //   bandingUserId: this.$store.state.puserId,
            //   bandingUserPhone: this.userInfo.mobile,
            //   bandingUserName: this.userInfo.name,
            //   schoolId: this.$store.state.pschoolId,
            // },
          ],
        });
        if (result.code !== 200) {
          this.btn_loading = false;
          this.$toast(result.msg);
          return;
        }
        const { data, code, msg } = await this.$https.createPayOrder({
          outTradeNo: result.data,
        });
        if (code !== 200) {
          this.btn_loading = false;
          // this.btn_loading_text = ''
          this.$toast(`下单失败`);
          return false;
        }
        const jsinit = await wxSDK.jsSDKConfig();
        if (jsinit == "err") {
          this.$toast("微信sdk初始化失败，请重试");
          return false;
        }
        const resultPay = await wxSDK.chooseWXPay(data);

        if (resultPay == "支付失败") {
          this.$toast("支付失败");
        } else if (resultPay == "支付取消") {
          // 跳转订单列表
          this.$toast("支付取消");
        } else {
          // 支付成功
          console.log("支付成功-----", resultPay);
          /**注意此位置
           * 
           * 更新订单日后还要作
           * */ 
          // let update=await this.$https.updateOrder({
          //   bandingSaveDTOS: [...this.person]
          // })
          const res = await this.$https.getPayOrder({
            outTradeNo: result.data,
          });
            //  bandingSaveDTOS: [...this.person]
          if (res.code !== 200) {
            this.$toast("查询支付结果失败");
            return;
          }
          this.$toast("支付成功");
          setTimeout(() => {
            this.$router.push("/orderList");
          }, 1000);
          console.log("查询支付状态", res);
        }
        this.btn_loading = false;
        this.btn_loading_text = "提交订单";
      } catch (error) {
        this.btn_loading = false;
        this.btn_loading_text = "提交订单";
        console.log("下单失败-----", error);
        this.$toast("下单失败，请重试");
      }
    },
  },

  components: {
    BindPerson,
    BindPersonDetail,
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem 0.5rem;
  border-radius: 0.75rem;
  padding-bottom: 1.5rem;

  .title {
    color: #1a1a1a;
    font-size: 0.88rem;
    padding: 1.06rem;
    padding-bottom: 0.5rem;
    /* border-bottom: 1px solid rgba(244, 244, 246, 0.99); */
    .title-new {
      height: 0.5rem;
      padding: 0.1rem;
      background: #37a5da;
      margin-right: 0.2rem;
    }
  }

  .list {
    .list-item {
      padding: 0.4rem 1.6rem;
      color: #454f63;
      font-size: 0.85rem;
      display: flex;
      align-items: center;

      /* justify-content: space-between; */
      > span:first-child {
        display: inline-block;
        width: 4.5rem;
        text-align: left;
        color: #666666;
        font-size: 0.85rem;
      }

      > span:last-child {
        font-size: 0.85rem;
      }
    }
  }
}
.agree {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 7.5rem;
  .sumTotal {
    width: 10rem;
    height: 2rem;
    float: left;
    margin-left: 1.3rem;
    font-size: 0.8rem;
    .money {
      font-size: 0.8rem;
      font-weight: bold;
      color: #c29f55;
    }
    img {
      width: 1rem;
      height: 0.7rem;
      display: inline-block;
    }
  }
  .btn {
    float: left;
    color: #2a2e43;
    font-size: 1.13rem;
    margin-left: 0.55rem;
    width: 10.5rem;
    height: 3.25rem;
    text-align: center;
    line-height: 3.25rem;
    font-weight: 400;
    border-radius: 2rem;
    background: linear-gradient(270deg, #e1bb73 0%, #f0ddb7 100%);
  }
}
.pop {
  font-size: 0.75rem;
  margin-left: 1.3rem;
  margin-top: 0.5rem;
  color: #666666;
}
</style>
